import apiClient from '@/api/apiClient'

export const getTags = accountId =>
  apiClient.get(`api/v1/accounts/${accountId}/tags`)

export const createTag = (accountId, name) =>
  apiClient.post(`api/v1/accounts/${accountId}/tags`, { name })

export const updateTag = (accountId, id, name) =>
  apiClient.patch(`api/v1/accounts/${accountId}/tags/${id}`, { name })

export const deleteTag = (accountId, id) =>
  apiClient.delete(`api/v1/accounts/${accountId}/tags/${id}`)
